import * as React from 'react';
import {Box, Typography, List, ListItem, ListItemText, Divider, Grid, Link, Paper} from '@mui/material';
import {OrderDetail} from '../../../api/models';

export const OrderDetails: React.FC<{order: OrderDetail}> = ({order}) => {
    return (
        <Box sx={{padding: 3}}>
            <Paper elevation={3} sx={{padding: 3}}>
                {' '}
                {/* Add a Paper component for visual separation */}
                <Grid container spacing={2}>
                    {' '}
                    {/* Use Grid for layout */}
                    <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                            Order Details
                        </Typography>
                        <Typography variant='subtitle1' gutterBottom>
                            Order ID: {order.orderId}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                            Order Invoice
                        </Typography>
                        <Typography variant='subtitle1' gutterBottom>
                            <Link href={`https://socialmart.com/api/order/invoice?orderid=${order.orderId}`}>
                                Download PDF
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {' '}
                        {/* Shop and Buyer details side-by-side on larger screens */}
                        <Box>
                            <Typography variant='h6' gutterBottom>
                                Shop Details
                            </Typography>
                            <Typography variant='body2'>Name: {order.shopDetails.name}</Typography>
                            <Link href={order.shopDetails.websiteUrl} target='_blank' rel='noopener noreferrer'>
                                {order.shopDetails.websiteUrl}
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Typography variant='h6' gutterBottom>
                                Buyer Details
                            </Typography>
                            <Typography variant='body2'>Name: {order.buyerDTO.name}</Typography>
                            <Typography variant='body2'>Email: {order.buyerDTO.email}</Typography>
                            <Typography variant='body2'>Mobile: {order.buyerDTO.mobileNumber}</Typography>
                            <Typography variant='body2'>Address: {order.buyerDTO.address}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        {/* Items List */}
                        <Typography variant='h6' gutterBottom>
                            Items
                        </Typography>
                        <List disablePadding>
                            {order.items.map((item) => (
                                <React.Fragment key={item.id}>
                                    <ListItem sx={{padding: 0}}>
                                        {' '}
                                        {/* No padding within list */}
                                        <ListItemText
                                            primary={item.title}
                                            secondaryTypographyProps={{component: 'div'}}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography variant='body2' component='span'>
                                                        Quantity: {item.quantity}
                                                    </Typography>{' '}
                                                    <br />
                                                    <Typography variant='body2' component='span'>
                                                        Price: ₹{(item.priceInPaise / 100).toFixed(2)}
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                    <Divider component='li' /> {/* Make Divider a list item */}
                                </React.Fragment>
                            ))}
                        </List>
                    </Grid>
                    <Grid item xs={12}>
                        {' '}
                        {/* Payment and Status */}
                        <Box>
                            <Typography variant='h6' gutterBottom>
                                Payment Details
                            </Typography>
                            <Typography variant='body2'>
                                Cart Amount: ₹{(order.paymentDetails.cartAmount / 100).toFixed(2)}
                            </Typography>
                            <Typography variant='body2'>
                                GST: ₹{(order.paymentDetails.gstAmount / 100).toFixed(2)}
                            </Typography>
                            <Typography variant='body2'>
                                Final Amount: ₹{(order.paymentDetails.finalAmount / 100).toFixed(2)}
                            </Typography>
                            <Typography variant='body2'>Customer VPA: {order.customerVPA}</Typography>
                            <Typography variant='body2'>Receiver VPA: {order.paymentDetails.receiverVPA}</Typography>
                            <Typography variant='body2'>Display Name: {order.paymentDetails.displayName}</Typography>

                            <Typography variant='body1' gutterBottom sx={{marginTop: 2}}>
                                Status: {order.statusMessage}
                            </Typography>
                            <Typography variant='body1' gutterBottom>
                                Transaction ID: {order.transactionID}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>
    );
};

export default OrderDetails;
